import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { SessionService } from '../../services/session.service';

@Component({
  selector: 'medical-appointment-data-contract',
  templateUrl: './data-contract.component.html',
  styleUrls: ['./data-contract.component.css']
})
export class DataContractComponent implements OnInit {

  nombre : string;
  contrato: string;
  direccion: string;
  telefono: string;

  constructor(
    private userService : UserService,
    private _sessionService : SessionService
  ) { }

  ngOnInit() {

    this.nombre = this._sessionService.getDataContract().name;
    this.contrato = this._sessionService.getSelectContract();
    this.direccion = this._sessionService.getDataContract().addres;
    this.userService.getDataUser(this._sessionService.getSelectContract(), '-').subscribe(
      res => {
        this.telefono = res.residentialPhone;
      },
      err => {
        console.log(err);
      }
    )
  }

}



// WEBPACK FOOTER //
// /app/src/app/shared/components/data-contract/data-contract.component.ts